// Origin of the API. The path prefix (/api/...) lives in the service files, matching the
// parent platform's convention — REACT_APP_API_URL is just the host.
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8020';
export const APP_NAME = 'Maghaweer.ai';
